import { jsx, Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { ConciergePartItem } from "./ConciergePartItem.js";
function normalizeParts(raw) {
  const resultByCallId = /* @__PURE__ */ new Map();
  for (const p of raw) {
    if (p.type === "tool-result") {
      resultByCallId.set(p.toolCallId, p);
    }
  }
  const consumedResultIds = /* @__PURE__ */ new Set();
  const out = [];
  for (const p of raw) {
    const part = p;
    if (part.type === "tool-call") {
      const matching = resultByCallId.get(part.toolCallId);
      const merged = {
        type: `tool-${part.toolName}`,
        toolCallId: part.toolCallId,
        state: matching ? "result" : "call",
        input: part.args
      };
      if (matching) {
        merged.output = matching.result;
        consumedResultIds.add(part.toolCallId);
      }
      out.push(merged);
    } else if (part.type === "tool-result") {
      if (!consumedResultIds.has(part.toolCallId)) {
        out.push({
          type: `tool-${part.toolName}`,
          toolCallId: part.toolCallId,
          state: "result",
          output: part.result
        });
      }
    } else {
      out.push(p);
    }
  }
  return out;
}
function ConciergeMessagePart({
  parts,
  onProductClick,
  isStreaming,
  pdpStacklineSku,
  isOnChatWidget,
  apiBaseUrl
}) {
  if (!parts || parts.length === 0) return null;
  const normalizedParts = useMemo(() => normalizeParts(parts), [parts]);
  return /* @__PURE__ */ jsx(Fragment, { children: normalizedParts.map((part, index) => /* @__PURE__ */ jsx(
    ConciergePartItem,
    {
      part,
      allParts: normalizedParts,
      onProductClick,
      isStreaming,
      pdpStacklineSku,
      isOnChatWidget,
      apiBaseUrl
    },
    `${part.type}-${index}`
  )) });
}
export {
  ConciergeMessagePart
};
//# sourceMappingURL=index.js.map
